import React from "react";
import PropTypes from "prop-types";
import Loadable from "theme/components/helpers/Loadable";

const GridCards = ({ children }) => (
  <div className="grid-cards">{children}</div>
);

GridCards.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  loading: PropTypes.bool,
};

export default Loadable((props) => !props.loading, true)(GridCards);
